import type { AxisTickProps } from '@nivo/axes';
import { BAR_CHART_AXIS_LABEL_MAX_LENGTH, truncateChartLabel } from './analyticsHelpers';

const BAR_CHART_TICK_LABEL_OFFSET = 10;

export function renderTruncatedBarChartTick(tick: AxisTickProps<string | number>) {
  const fullLabel = String(tick.value);
  const displayLabel = truncateChartLabel(fullLabel, BAR_CHART_AXIS_LABEL_MAX_LENGTH);

  return (
    <g transform={`translate(${tick.x},${tick.y + BAR_CHART_TICK_LABEL_OFFSET})`}>
      <title>{fullLabel}</title>
      <text
        transform="rotate(-45)"
        textAnchor="end"
        dominantBaseline="middle"
        style={{ fontSize: 11, fill: '#4a6078' }}
      >
        {displayLabel}
      </text>
    </g>
  );
}
